<template>
<div class="chapter">
<div class="inner_page">
<div class="group">
<p class="C593"><span class="size_145"><span class="color_0B0E11"><strong><span id="id_6">Color</span></strong></span></span></p>
<p class="C580">Color is fundamental to many design decisions and should be thought of at the beginning of the design process, not at the end. Too many colors can be confusing and messy, while the controlled use of color creates a unified and balanced design. Color provokes an emotional response and can provide direction for the design. I’ll discuss color in more detail in the next chapter.</p>
</div>
<p class="C580"><em>Gray Play</em> is an example of controlled color.</p>
<div class="group">
<p class="C572"><img alt="" src="img/16_2.jpg"/></p>
<p class="C694"><span class="size_85"><em>Gray Play</em></span> <span class="size_70">(<span href="#/xhtml/28_Gray_Pla#page_80" title="Link target outside of Sample">page 80</span>)</span></p>
</div>
<div class="group">
<p class="C572"><img alt="" src="img/16_4.jpg"/><span class="size_85"><em>Intersections</em></span> <span class="size_90">(<span href="#/xhtml/22_Intersec#page_40" title="Link target outside of Sample">page 40</span>), detail</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 14___Color.vue?1964e445